import { type TableColumn, isBackendColumnFormat } from '@ipfabric/utils';

export const isBackendColumn = (column: TableColumn<any>): boolean =>
  isBackendColumnFormat(column.format);
